module.exports = __webpack_public_path__ + "img/10_day_tee.758dd219.svg";